/* tslint:disable */
/* eslint-disable */
export enum RoleEnum {
  MODEL = 'model',
  USER = 'user'
}
